// index.ts
import { polygon } from "@turf/helpers";
function bboxPolygon(bbox) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var west = Number(bbox[0]);
    var south = Number(bbox[1]);
    var east = Number(bbox[2]);
    var north = Number(bbox[3]);
    if (bbox.length === 6) {
        throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    }
    var lowLeft = [
        west,
        south
    ];
    var topLeft = [
        west,
        north
    ];
    var topRight = [
        east,
        north
    ];
    var lowRight = [
        east,
        south
    ];
    return polygon([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}
var turf_bbox_polygon_default = bboxPolygon;
export { bboxPolygon, turf_bbox_polygon_default as default }; //# sourceMappingURL=index.js.map
